var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNonOccupant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M215.01 118.82C214.88 137.43 214.75 156.04 214.63 174.65C184.81 191.85 154.97 209.08 125.14 226.28V159.28C155.08 145.8 185.04 132.32 215.01 118.82Z",
    fill: "#72D09A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3999 105.57V179.45L125.16 226.28V159.3L80.7799 81.3403L36.3999 105.57Z",
    fill: "#29A063"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 97.7201C25.47 100.33 30.93 102.96 36.4 105.57L80.78 81.34C100.66 110.07 120.51 138.77 140.39 167.5C170.21 151.31 200.04 135.14 229.86 118.96C210.06 87.3101 190.28 55.64 170.48 24C140.58 37.23 110.68 50.4599 80.78 63.6899C60.52 75.0399 40.26 86.3701 20 97.7201Z",
    fill: "#29A063"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 97.7201L36.4 105.57L80.78 81.34L125.16 159.3L140.39 167.5L80.78 63.6899L20 97.7201Z",
    fill: "#72D09A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3999 179.45L113.89 139.48L80.7799 81.3403L36.3999 105.57V179.45Z",
    fill: "#B2E8C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonOccupant);
export default __webpack_public_path__ + "static/media/non-occupant.d7cf40ed7e629e491a4f073a37321a4b.svg";
export { ForwardRef as ReactComponent };